<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'QuikTip', to: { path: '/quiktips' } },
        { name: 'Create', to: { path: '/quiktips/create' } },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增 Quiktips</h2>
      <v-spacer></v-spacer>
    </div>
    <!-- block -->
    <QuiktipsCreateEdit></QuiktipsCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QuiktipsCreateEdit from '@/views/D-3_Quiktips/c/QuiktipsCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    QuiktipsCreateEdit,
  },
  created() {
    this.setQuikTip({});
  },
  computed: {
    ...mapState('QuikTip', [
      'quiktip',
    ]),
  },
  methods: {
    ...mapActions('QuikTip', ['setQuikTip']),
  },
};
</script>

<style></style>
